import GlobalPrototypes, {
  setGlobalAxiosInstance,
  setGlobalStoreInstance,
  setGlobalRouterInstance,
} from '@/config/services/globalPrototypes.ts'

export default function registerGlobalPrototypes(app, axios, store, router) {
  // To avoid needing import of axios, store and router within 'src/config/services/global', we set them via methods
  setGlobalAxiosInstance(axios)
  setGlobalStoreInstance(store)
  setGlobalRouterInstance(router)

  // Options API only
  // These should be removed when the app is fully migrated to Composition API
  // For composition API, use composables from src/composables/utils
  app.config.globalProperties.$dateFormat = GlobalPrototypes.dateFormat
  app.config.globalProperties.$cacheHttp = GlobalPrototypes.cacheHttp
  app.config.globalProperties.$axios = GlobalPrototypes.axios
  app.config.globalProperties.$clone = GlobalPrototypes.clone
  app.config.globalProperties.$uuid = GlobalPrototypes.uuid
  app.config.globalProperties.$sanitize = GlobalPrototypes.sanitize
  app.config.globalProperties.$getSize = GlobalPrototypes.getSize
  app.config.globalProperties.$getFileTypeAndSize = GlobalPrototypes.getFileTypeAndSize
  app.config.globalProperties.$getFileTypeAndFolderSize = GlobalPrototypes.getFileTypeAndFolderSize
  app.config.globalProperties.$getFolderSize = GlobalPrototypes.getFolderSize
  app.config.globalProperties.$sleep = GlobalPrototypes.sleep
  app.config.globalProperties.$switchLocale = GlobalPrototypes.switchLocale
  app.config.globalProperties.$overlappingDateRanges = GlobalPrototypes.overlappingDateRanges
  app.config.globalProperties.$compare = GlobalPrototypes.compare
  app.config.globalProperties.$defaultRoute = GlobalPrototypes.defaultRoute
  app.config.globalProperties.$onboardingDefaultRoute = GlobalPrototypes.onboardingDefaultRoute
  app.config.globalProperties.$getCurrentLocale = GlobalPrototypes.getCurrentLocale
  app.config.globalProperties.$toastNotify = GlobalPrototypes.toastNotify
  app.config.globalProperties.$moment = GlobalPrototypes.moment
  app.config.globalProperties.$hasSlotContent = GlobalPrototypes.hasSlotContent
  app.config.globalProperties.$isA11yDemoSchool = GlobalPrototypes.isA11yDemoSchool
}
